__turbopack_context__.v({
  "cardsTrack": "PlansSection-module__fkylAG__cardsTrack",
  "desktopGrid": "PlansSection-module__fkylAG__desktopGrid",
  "mobileStack": "PlansSection-module__fkylAG__mobileStack",
  "shell": "PlansSection-module__fkylAG__shell",
});
